import { isAuthed } from '../../lib/getJWT';
import getTenant from '../../lib/getTenant';

export const getRedirectURL = (dest = window.location.origin) => {
  const r = dest ? `?redirect=${encodeURIComponent(dest)}` : ``;
  const origin = window.location.origin.replace(/\/\/[^.]+\./, '//hub.');
  return `${origin}/${getTenant()}/login${r}`;
};

export const redirect = () => {
  window.location.href = getRedirectURL(window.location.href);
};

export const ifNotAuthedRedirect = () => {
  if (!isAuthed()) redirect();
};
